<template>
  <div>
    <vs-table :data="history.items" max-items="10" pagination class="mass-history-card">
      <template slot="thead">
        <vs-th>Carga</vs-th>
        <vs-th>Nome</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Resumo</vs-th>
        <vs-th>Criado por</vs-th>
        <vs-th>Criado em</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :key="row.id" v-for="row in data">
            <vs-td>#{{ row.id }}</vs-td>
            <vs-td>{{ row.name }}</vs-td>
            <vs-td><vs-chip :color="statusColor(row.status)">{{ humanStatus(row.status) }}</vs-chip></vs-td>
            <vs-td>
              <span class="text-small">
                Total: {{ row.total_tenants }} · OK: {{ row.success_tenants }} · Falhas: {{ row.failed_tenants }}
              </span>
            </vs-td>
            <vs-td>{{ row.requester_name || '-' }}</vs-td>
            <vs-td>{{ row.created_at || '-' }}</vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="primary"
                type="border"
                icon-pack="feather"
                :icon="isHistoryDetailOpen(row.id) ? 'icon-chevron-up' : 'icon-eye'"
                :title="isHistoryDetailOpen(row.id) ? 'Fechar detalhe' : 'Abrir detalhe'"
                @click="$emit('show-batch-detail', row.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-4 batch-detail-panel" v-if="selectedBatchDetail">
      <div class="batch-detail-header">
        <h4 class="mb-0 batch-detail-title">Itens da carga #{{ selectedBatchDetail.id }}</h4>
        <vs-button size="small" type="flat" color="warning" @click="$emit('close-batch-detail')">Fechar</vs-button>
      </div>

      <vs-table :data="selectedBatchDetail.items || []" max-items="20" pagination>
        <template slot="thead">
          <vs-th>Dash</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Categoria criada</vs-th>
          <vs-th>Tentativas</vs-th>
          <vs-th>Erro</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr v-for="row in data" :key="row.id">
              <vs-td>{{ row.tenant_name }}</vs-td>
              <vs-td><vs-chip :color="statusColor(row.status)">{{ humanStatus(row.status) }}</vs-chip></vs-td>
              <vs-td>{{ (row.resolved_ids && row.resolved_ids.group_name) || '-' }}</vs-td>
              <vs-td>{{ row.attempts || 0 }}</vs-td>
              <vs-td>
                <span v-if="row.error_message" class="text-danger">{{ shortError(row.error_message) }}</span>
                <span v-else>-</span>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { statusColor, humanStatus, shortError } from '../helpers';

export default {
  name: 'MassCustomerCategoriesHistorySection',
  props: {
    history: {
      type: Object,
      required: true,
    },
    selectedBatchDetail: {
      type: Object,
      default: null,
    },
  },
  methods: {
    statusColor,
    humanStatus,
    shortError,
    isHistoryDetailOpen(batchId) {
      const selectedId = Number(this.selectedBatchDetail && this.selectedBatchDetail.id);
      const rowId = Number(batchId);
      return !Number.isNaN(selectedId) && !Number.isNaN(rowId) && selectedId === rowId;
    },
  },
};
</script>

<style lang="scss">
.vs-con-table {
  .vs-con-tbody {
    background: #f8f8f8;
    border: 2px solid #f8f8f8;
  }

  .vs-table--header {
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    > span {
      display: flex;
      flex-grow: 1;
    }

    .vs-table--search {
      padding-top: 0;

      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;

        & + i {
          left: 1rem;
        }

        &:focus + i {
          left: 1rem;
        }
      }
    }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;

    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

      td {
        padding: 10px;
        text-align: center;

        &:first-child {
          border-top-left-radius: .5rem;
          border-bottom-left-radius: .5rem;
        }

        &:last-child {
          border-top-right-radius: .5rem;
          border-bottom-right-radius: .5rem;
        }
      }

      td.td-check {
        padding: 20px !important;
      }

      td.td.vs-table--td.actionTD > span {
        display: flex;
        justify-content: center;
      }
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
        justify-content: center !important;
      }
    }

    th.td-check {
      padding: 0 15px !important;
    }

    tr {
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
